// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/catalog_filtered_sets_list_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsCatalogFilteredSetsListDatatable } from "./constants";
import type {
  AppsCatalogFilteredSetsListDatatableParams,
  AppsCatalogFilteredSetsListDatatableResult,
} from "./types";

export const getDataTableAppsCatalogFilteredSetsListDatatable = reactQueryTableFetcherAdapter(
  appsCatalogFilteredSetsListDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      catalogId,
    }: AppsCatalogFilteredSetsListDatatableParams
  ): Promise<AppsCatalogFilteredSetsListDatatableResult> => {
    return fetch(
      "/apps/catalog_filtered_sets_list_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        catalog_id: catalogId,
      },
      { signal }
    );
  }
);
